(function() {
  const sections = [
    { id: 'shopify-section-template--29989550457164__section_LabMmy', selector: '.group-block-content' },
    { id: 'shopify-section-template--29989550457164__section_hwVrMy', selector: '.group-block' },
    { id: 'shopify-section-template--29989550457164__section_bwiifn', selector: '.group-block-content' },
    { id: 'shopify-section-template--30375180861772__section_tEJpzN', selector: '.group-block'},
    { id: 'shopify-section-template--30635348427084__section_UYJwha', selector: '.group-block'},
    { id: 'shopify-section-template--30635348427084__section_pMbeaX', selector: '.group-block'},
    { id: 'shopify-section-template--30002297176396__section_UHJWDt', selector: '.group-block-content' },
  ];

  sections.forEach(function(config) {
    const section = document.getElementById(config.id);
    if (!section) return;

    const groups = section.querySelectorAll(config.selector);

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    groups.forEach(function(group) {
      group.classList.add('icon-text-group');
      observer.observe(group);
    });
  });
})();
